<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xBQOF9/tc-custom/9781460349588.jpg?1704585954328" alt="This image is the cover for the book Marrying the Mistress"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Marrying the Mistress
      </h1>
      <p class="bookDescription body article font2">
        <p>Guardianand husband<br/><br/>Helene Follet hasn’t had close contact with Lord Burl Winterson since she chose to spend her life caring for his brother. Now she’s forced to live under Burl’s protection, because he has become guardian to her precious young son. Burl has grown hard and cynical over the years, while Helene covers her hurt with an ice-cool front. What she really craves is to finally find a loving home in his safe, strong arms. Neither can admit that they are still tantalised by the memory of one magical, fateful night</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Juliet Landon
      </h2>
      
      <p class="authorDescription body article">Juliet Landon is a professional embroiderer and lecturer, whose two disciplines go perfectly hand in hand. When she&rsquo;s not doing one, she&rsquo;s doing the other, often both on the same day. Her stories develop in her mind while stitches form on the fabric, and the one that wins depends on urgency and inclination. Juliet has been nominated for the Romantic Fiction Writer's Award, and she currently has at least another hundred ideas waiting to be released in the future.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin UK Ltd
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1a06fac4